export default "/images/vendor/flag-icons/flags/4x3/ae.svg?b263220156c66d18fff2a5f30b8f17ae";